
import { defineComponent, PropType } from "vue";

export interface LeaderboardBannerConfig {
  badge: string;
  title: string;
  description: string;
  heroImage: string;
  accentImage?: string;
  theme: string;
}

const BANNERS: Record<string, LeaderboardBannerConfig> = {
  totalIncome: {
    badge: "Income Leaders",
    title: "Top Earner",
    description:
      "Celebrate the partners earning the highest total income in your network for the selected period. These unstoppable leaders turn volume, team performance, and consistency into standout results.",
    heroImage: "media/leaderboard/unstoppa-bull.png",
    accentImage: "media/leaderboard/xxinfinity-with-text.png",
    theme: "earner"
  },
  reorderpurchase: {
    badge: "Marketplace Momentum",
    title: "Top Reseller",
    description:
      "Spotlight resellers driving the strongest reorder and product purchase activity. These champions keep products moving and energize the marketplace across the network.",
    heroImage: "media/leaderboard/bull-earth.png",
    accentImage: "media/leaderboard/xxinfinity.png",
    theme: "reseller"
  },
  newdirects: {
    badge: "Team Builders",
    title: "Top Directs",
    description:
      "Recognize the connectors bringing in the most new direct enrollments during your selected range. Every name here represents fresh growth and a stronger future for the team.",
    heroImage: "media/leaderboard/20-years.png",
    accentImage: "media/leaderboard/xxinfinity-with-text.png",
    theme: "directs"
  }
};

export default defineComponent({
  name: "LeaderboardBanner",
  props: {
    metric: {
      type: String as PropType<string>,
      required: true
    }
  },
  computed: {
    banner(): LeaderboardBannerConfig {
      return BANNERS[this.metric] || BANNERS.totalIncome;
    },
    bannerClass(): string {
      return `leaderboard-banner--${this.banner.theme}`;
    }
  }
});
